import type { StoreApi } from "zustand";
import type { TChatStore } from "../chat-store.types";
import type { TPhoneData } from "./ui.types";
import { phoneInitialState } from "./ui.initial-state";

type TSetState = StoreApi<TChatStore>["setState"];

export const createPhoneActions = (set: TSetState) => ({
  setPhoneLoading: (chatId: string) =>
    set(() => ({ phone: { ...phoneInitialState, loading: true, chatId } })),

  setPhoneFulfilled: (chatId: string, source: TPhoneData | string) =>
    set((state) => {
      if (state.phone.chatId !== chatId) return {};
      return { phone: { ...phoneInitialState, fetched: true, source, chatId } };
    }),

  setPhoneRejected: (source: TPhoneData | string) =>
    set(() => ({ phone: { ...phoneInitialState, error: true, source } })),

  resetPhone: () => set(() => ({ phone: phoneInitialState })),
});
